export default "__VITE_ASSET__WiJ4gdid__"